import React from 'react';
import { ModalContainer } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { useAnalyticsOpenScreen } from 'hooks/useAnalyticsOpenScreen';
import {
	Close,
	Container,
	List,
	Title,
	Subtitle,
} from './CallToActionExams.styles';
import { ReactComponent as ChatIcon } from 'App/assets/img/chat.svg';
import computer from 'App/assets/callToActionExams/computer.png';
import calendar from 'App/assets/callToActionExams/calendar.png';
import candidate from 'App/assets/callToActionExams/candidate.png';
import labs from 'App/assets/callToActionExams/labs.png';
import Analytics from 'helpers/analytics';

interface ICallToActionExamsProps {
	onFinish: () => void;
}

export const CallToActionExams = ({
	onFinish,
}: ICallToActionExamsProps): JSX.Element => {
	useAnalyticsOpenScreen({
		context: 'candidate',
		trackName: 'Exams Profile',
	});

	const onSubmit = () => {
		Analytics.track('candidate', 'Exams Profile Support');
		if (window.fcWidget) {
			window.fcWidget.open();
		}
		onFinish();
	};

	return (
		<ModalContainer
			closeOnlyOnTheButton
			visible
			width="530px"
			height="750px"
			borderRadius="6px"
		>
			<Container>
				<Title>
					¿Sabías que ya puedes realizar estudios médicos a tus candidatos?
				</Title>
				<Subtitle>
					Reduce el tiempo que dedicas a los procesos de ingreso, optimizando la
					evaluación de tus candidatos
				</Subtitle>
				<List>
					<li>
						<img src={computer} />
						<span>
							Visualiza la aptitud laboral de tus candidatos emitida por el
							médico
						</span>
					</li>
					<li>
						<img src={calendar} />
						<span>
							Asigna las citas de los exámenes médicos y exámenes de laboratorio
							para tus candidatos
						</span>
					</li>
					<li>
						<img src={candidate} />
						<span>
							Crea perfiles de puesto y solicita los exámenes para cada uno
						</span>
					</li>
					<li>
						<img src={labs} />
						<span>
							Tus candidatos recibirán las indicaciones para realizar sus
							exámenes en nuestra red de laboratorios a nivel nacional.
						</span>
					</li>
				</List>
				<Title>Contáctanos para más información</Title>
				<Button onClick={onSubmit} width="300px">
					Contactar a soporte &nbsp; &nbsp; <ChatIcon />
				</Button>
				<Close onClick={onFinish}>En otro momento</Close>
			</Container>
		</ModalContainer>
	);
};
